import { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { useThemeMode } from '../../../../../../_metronic/partials'
import AddConvertibleClassModal from './add-convertible-class-modal'
import AddSharedClassModal from './add-security-class-modal'
import AddWarrantClassModal from './add-security-warrant-issuance'
import threeDots from '../../../../../../_metronic/assets/images/svg/investor/threeDots.svg'
import { DataTableServerShareClass } from './DataTableServerSideShareClass'
import { DataTableServerConvertibleClass } from './DataTableServerSideConvertibleClass'
import { DataTableServerWarrantClass } from './DataTableServerSideWarrantClass'
import clsx from 'clsx'
import { KTSVG, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import searchIcon from '../../../../../../_metronic/assets/images/svg/data-room/search-icon-grey.svg'
import { useStakeholders } from '../../../Stakeholders'
import { Filter } from '../../../../widgets/components/General/Filter'
import { useAuth } from '../../../../auth'
import { toast } from 'react-toastify'
import {
  exportConvertibleSecurityClasses,
  exportShareSecurityClasses,
  exportWarrantSecurityClasses,
} from '../../core/_requests'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../../../../app/hooks/gtmHelpers'
import { TransactionModalType } from '../../core/_models'

export default function SecurityClass() {
  const { formatMessage } = useIntl()
  const [isCreate, setIsCreate] = useState(true)
  const [isCreateOrUpdate, setIsCreateOrUpdate] = useState(false)
  const [isConvertibleCreateOrUpdate, setIsConvertibleCreateOrUpdate] = useState(false)
  const [isWarrantCreateOrUpdate, setIsWarrantCreateOrUpdate] = useState(false)
  const { setCreatedShareClassFromOtherClasses, setCreatedShareClassEditConvertibleClassId } =
    useStakeholders()
  const [shareClassId, setShareClassId] = useState<string | null>(null)
  const [convertibleClassId, setConvertibleClassId] = useState<string | null>(null)
  const [warrantClassId, setWarrantClassId] = useState<string | null>(null)
  const [onResetFilter, setOnResetFilter] = useState(false)

  const sidebarOptions = [
    { title: formatMessage({ id: 'Share Class' }), id: 1 },
    { title: formatMessage({ id: 'Convertible Class' }), id: 2 },
    { title: formatMessage({ id: 'Warrant Class' }), id: 3 },
  ]

  const { mode } = useThemeMode()
  const { companyId, currentUser } = useAuth()
  const [sidebar, setSidebar] = useState(1)
  const [globalFilter, setGlobalFilter] = useState('')
  const [convertibleGlobalFilter, setConvertibleGlobalFilter] = useState('')
  const [warrantGlobalFilter, setWarrantGlobalFilter] = useState('')
  const [isShareClassDropdown, setIsShareClassDropdown] = useState(false)
  const {
    setShareSecurityClassesSortFilter,
    selectedShareSecurityClassesSortFilter,
    selectedConvertibleSecurityClassesSortFilter,
    selectedConvertibleSecurityClassesRateFilter,
    setConvertibleSecurityClassesFilter,
    setWarrantSecurityClassesFilter,
    selectedWarrantSecurityClassesSortFilter,
    setSelectedWarrantSecurityClassesSortFilter,
    setSelectedShareSecurityClassesSortFilter,
    setSelectedConvertibleSecurityClassesSortFilter,
    setSelectedConvertibleSecurityClassesRateFilter,
  } = useStakeholders()

  const [activeModal, setActiveModal] = useState<TransactionModalType>('none')
  const [modalType, setModalType] = useState<TransactionModalType>('none')

  const openModal = (modalType: TransactionModalType) => {
    setActiveModal(modalType)
  }

  const closeModal = () => {
    setShareClassId(null)
    setConvertibleClassId(null)
    setWarrantClassId(null)
    setActiveModal('none')
  }

  const onExportShareSecurityClasses = async () => {
    try {
      const {
        data: { data: values, success, errors },
      } = await exportShareSecurityClasses(companyId!)
      if (success) {
        toast.success(formatMessage({ id: 'Documents exported successfully' }))
        const url = window.URL.createObjectURL(new Blob([values]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'shareSecurityClasses.csv')
        document.body.appendChild(link)
        link.click()
        link.remove()
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.ShareSecurityClassExportedSuccessful,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
            },
          },
        })
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.ShareSecurityClassExportedFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
            },
          },
        })
      }
    } catch (err: any) {
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.ShareSecurityClassExportedFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    }
  }

  const onExportConvertibleSecurityClasses = async () => {
    try {
      const {
        data: { data: values, success, errors },
      } = await exportConvertibleSecurityClasses(companyId!)
      if (success) {
        toast.success(formatMessage({ id: 'Convertible security classes exported successfully' }))
        const url = window.URL.createObjectURL(new Blob([values]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'convertibleSecurityClasses.csv')
        document.body.appendChild(link)
        link.click()
        link.remove()
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.ConvertibleSecurityClassExportedSuccessful,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
            },
          },
        })
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.ConvertibleSecurityClassExportedFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              error: errors[0],
            },
          },
        })
      }
    } catch (err: any) {
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.ConvertibleSecurityClassExportedFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    }
  }

  const onExportWarrantSecurityClasses = async () => {
    try {
      const {
        data: { data: values, success, errors },
      } = await exportWarrantSecurityClasses(companyId!)
      if (success) {
        toast.success(formatMessage({ id: 'Warrant security classes exported successfully' }))
        const url = window.URL.createObjectURL(new Blob([values]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'warrantSecurityClasses.csv')
        document.body.appendChild(link)
        link.click()
        link.remove()
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.WarrantSecurityClassExportedSuccessful,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
            },
          },
        })
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.WarrantSecurityClassExportedFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
            },
          },
        })
      }
    } catch (err: any) {
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.WarrantSecurityClassExportedFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    }
  }

  return (
    <>
      <div className='d-md-flex mt-4 py-4 pt-2 justify-content-between w-100 align-items-center'>
        <div
          className={`mb-4 mb-md-0 sidebar-investor-db col-md-1 d-flex w-md-50 w-100 ${mode === 'dark' ? 'sc-tabs-line-dark' : 'sc-tabs-line'
            } `}
        >
          <div
            className=' d-flex'
            style={{
              display: 'flex',
              overflowX: 'scroll',
              whiteSpace: 'nowrap',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            {sidebarOptions.map((sideTabs: any, index: number) => (
              <>
                <ul
                  className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent text-muted fs-7 fw-semibold flex-nowrap mobile-tab-both my-md-0 mb-0 px-2 mt-0'
                  style={{ display: 'flex', flexWrap: 'nowrap', borderWidth: '0px' }}
                >
                  <div>
                    <li
                      key={index}
                      className={
                        `nav-link text-active-primary fw-normal fs-6 py-3 ps-3 d-flex align-items-center cursor-pointer` +
                        (sidebar === index + 1
                          ? '  border-top-0 border border-left-0 border-right-0 border-bottom-3 border-primary text-primary border-5'
                          : '')
                      }
                      onClick={() => {
                        setSelectedConvertibleSecurityClassesSortFilter('')
                        setSelectedWarrantSecurityClassesSortFilter('')
                        setSelectedShareSecurityClassesSortFilter('')
                        setSelectedConvertibleSecurityClassesRateFilter('')
                        setGlobalFilter('')
                        setConvertibleGlobalFilter('')
                        setWarrantGlobalFilter('')
                        setSidebar(index + 1)
                        setShareSecurityClassesSortFilter(false)
                        setConvertibleSecurityClassesFilter(false)
                        setWarrantSecurityClassesFilter(false)
                        setOnResetFilter(true)
                      }}
                    >
                      {sideTabs.title}
                    </li>
                  </div>
                </ul>
              </>
            ))}
          </div>
        </div>

        <div className={`w-md-50 pb-1 ${mode === 'dark' ? 'sc-tabs-line-dark' : 'sc-tabs-line'} `} style={{ marginBottom: '-4px' }}>
          {/* DROPDOWN BUTTON FOR MOBILE VIEW */}
          <Dropdown className='d-block d-md-none mb-3'>
            <Dropdown.Toggle
              id='dropdown-custom-components'
              className='btn bg-primary justify-content-center text-mute font-weight-400 font-size-13 height-36 d-flex align-items-center w-100'
            >
              {formatMessage({ id: 'Add New Class' })}
            </Dropdown.Toggle>

            <Dropdown.Menu className='p-0'>
              <Dropdown.Item
                eventKey='Option 1'
                className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                onClick={() => {
                  setCreatedShareClassFromOtherClasses(undefined)
                  setCreatedShareClassEditConvertibleClassId(undefined)
                  setIsCreate(true)
                  openModal('AddSecurityClassModal')
                }}
              >
                {formatMessage({ id: 'Add Share Class' })}
              </Dropdown.Item>
              <Dropdown.Item
                eventKey='Option 2'
                className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                onClick={() => {
                  setCreatedShareClassFromOtherClasses(undefined)
                  setCreatedShareClassEditConvertibleClassId(undefined)
                  setIsCreate(true)
                  openModal('AddConvertibleClassModal')
                }}
              >
                {formatMessage({ id: 'Add Convertible Class' })}
              </Dropdown.Item>
              <Dropdown.Item
                eventKey='Option 3'
                className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                onClick={() => {
                  setCreatedShareClassFromOtherClasses(undefined)
                  setCreatedShareClassEditConvertibleClassId(undefined)
                  setIsCreate(true)
                  openModal('AddWarrantClassModal')
                }}
              >
                {formatMessage({ id: 'Add Warrant Class' })}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <div className='d-flex gap-2 align-items-center justify-content-md-end justify-content-between'>
            <div className='h-100 bg-white d-flex rounded height-36 align-items-center'>
              <button
                className={clsx('text-clr88 btn btn-sm btn-flex fw-semibold py-2 font-size-12 height-36')}
                id='fc-toogle'
                title='Sort and Filter'
                data-bs-toggle='tooltip'
                data-bs-placement='left'
                data-bs-dismiss='click'
                data-bs-trigger='hover'
                onClick={() => {
                  if (sidebar === 1) {
                    setShareSecurityClassesSortFilter(true)
                    if (selectedShareSecurityClassesSortFilter) {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.ShareSecurityClassFilterRemovedSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                          },
                        },
                      })
                    } else {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.ShareSecurityClassFilterAppliedSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            share_security_class_type: 'Class Name Sort Order',
                          },
                        },
                      })
                    }
                  } else if (sidebar === 2) {
                    setConvertibleSecurityClassesFilter(true)
                    if (selectedConvertibleSecurityClassesSortFilter) {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.ConvertibleSecurityClassFilterRemovedSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                          },
                        },
                      })
                    } else {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.ConvertibleSecurityClassFilterAppliedSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            convertible_security_class_type:
                              'Class Name Sort Order',
                          },
                        },
                      })
                    }
                  } else if (sidebar === 3) {
                    setWarrantSecurityClassesFilter(true)
                    if (selectedWarrantSecurityClassesSortFilter) {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.WarrantSecurityClassFilterRemovedSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                          },
                        },
                      })
                    } else {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.WarrantSecurityClassFilterAppliedSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            warrant_security_class_type: 'Class Name Sort Order',
                          },
                        },
                      })
                    }
                  }
                }}
              >
                <KTSVG
                  path={toAbsoluteUrl('/media/icons/duotune/general/gen031.svg')}
                  className='svg-icon-6 svg-icon-muted me-1'
                />
                <span className='d-none d-md-block'>{formatMessage({ id: 'Filter' })}</span>
                {selectedShareSecurityClassesSortFilter
                  ? '*'
                  : selectedConvertibleSecurityClassesSortFilter ||
                    selectedConvertibleSecurityClassesRateFilter
                    ? '*'
                    : selectedWarrantSecurityClassesSortFilter
                      ? '*'
                      : ''}
              </button>
            </div>

            <form className='align-items-center d-flex height-36 w-100'>
              <span className='svg-icon svg-icon-3 position-absolute ms-2'>
                <img src={searchIcon} alt='Search icon' />
              </span>
              <DebouncedInput
                value={
                  sidebar === 1
                    ? globalFilter
                    : sidebar === 2
                      ? convertibleGlobalFilter
                      : sidebar === 3
                        ? warrantGlobalFilter
                        : ''
                }
                onChange={(value) => {
                  if (sidebar === 1) {
                    setGlobalFilter(String(value))
                    if (String(value).length > 0) {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.ShareSecurityClassSearchSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            search_value: value,
                          },
                        },
                      })
                    }
                  } else if (sidebar === 2) {
                    setConvertibleGlobalFilter(String(value))
                    if (String(value).length > 0) {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.ConvertibleSecurityClassSearchSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            search_value: value,
                          },
                        },
                      })
                    }
                  } else if (sidebar === 3) {
                    setWarrantGlobalFilter(String(value))
                    if (String(value).length > 0) {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.WarrantSecurityClassSearchSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            search_value: value,
                          },
                        },
                      })
                    }
                  }
                }}
                className='bg-body form-control form-control-flush ps-10 rounded-2 font-size-12 font-weight-400 height-36'
                placeholder='Search by Class Name'
              />
            </form>
            {/* DROPDOWN BUTTON FOR DESKTOP VIEW */}
            <Dropdown className='d-none d-md-block height-36'>
              <Dropdown.Toggle
                id='dropdown-custom-components'
                className='btn bg-primary custom-button-property justify-content-center font-weight-400 font-size-12 py-3 d-flex align-items-center w-100 height-36'
              >
                {formatMessage({ id: 'Add New Class' })}
              </Dropdown.Toggle>

              <Dropdown.Menu className='p-0'>
                <Dropdown.Item
                  eventKey='Option 1'
                  className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                  onClick={() => {
                    setCreatedShareClassFromOtherClasses(undefined)
                    setCreatedShareClassEditConvertibleClassId(undefined)
                    setIsCreate(true)
                    openModal('AddSecurityClassModal')
                  }}
                >
                  {formatMessage({ id: 'Add Share Class' })}
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey='Option 2'
                  className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                  onClick={() => {
                    setCreatedShareClassFromOtherClasses(undefined)
                    setCreatedShareClassEditConvertibleClassId(undefined)
                    setIsCreate(true)
                    openModal('AddConvertibleClassModal')
                  }}
                >
                  {formatMessage({ id: 'Add Convertible Class' })}
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey='Option 3'
                  className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                  onClick={() => {
                    setCreatedShareClassFromOtherClasses(undefined)
                    setCreatedShareClassEditConvertibleClassId(undefined)
                    setIsCreate(true)
                    openModal('AddWarrantClassModal')
                  }}
                >
                  {formatMessage({ id: 'Add Warrant Class' })}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <div className='position-relative'>
              <div className='dropdown-export-container'>
                <Dropdown className='height-36'>
                  <Dropdown.Toggle className='btn btn-white table-three-dots dots-container'>
                    <img src={threeDots} alt='' className='three-dots-image' />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className='m-1'>
                    <Dropdown.Item
                      className='text-dark ps-5'
                      onClick={() => {
                        if (sidebar === 1) {
                          onExportShareSecurityClasses()
                        } else if (sidebar === 2) {
                          onExportConvertibleSecurityClasses()
                        } else if (sidebar === 3) {
                          onExportWarrantSecurityClasses()
                        }
                      }}
                    >
                      {formatMessage({ id: 'Export to CSV' })}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='bg-white rounded-2 position-relative mb-4'>
        {sidebar === 1 && (
          <>
            {/* <ShareClassTable openModal={openModal} closeModal={closeModal} activeModal={activeModal} selectedIndex={selectedIndex} setSelectedIndex={setSelectedIndex} /> */}
            <DataTableServerShareClass
              openModal={openModal}
              closeModal={closeModal}
              activeModal={activeModal}
              setIsCreate={setIsCreate}
              selectedShareSecurityClassesSortFilter={selectedShareSecurityClassesSortFilter}
              globalFilter={globalFilter}
              setGlobalFilter={setGlobalFilter}
              isCreateOrUpdate={isCreateOrUpdate}
              setIsCreateOrUpdate={setIsCreateOrUpdate}
              setSidebar={setSidebar}
              shareClassId={shareClassId}
              setShareClassId={setShareClassId}
            />
          </>
        )}{' '}
        {sidebar === 2 && (
          <>
            {/* <ConvertibleClassTable openModal={openModal} closeModal={closeModal} activeModal={activeModal} selectedIndex={selectedIndex} setSelectedIndex={setSelectedIndex} /> */}
            <DataTableServerConvertibleClass
              openModal={openModal}
              closeModal={closeModal}
              activeModal={activeModal}
              setIsCreate={setIsCreate}
              selectedConvertibleSecurityClassesRateFilter={
                selectedConvertibleSecurityClassesRateFilter
              }
              selectedConvertibleSecurityClassesSortFilter={
                selectedConvertibleSecurityClassesSortFilter
              }
              globalFilter={convertibleGlobalFilter}
              setGlobalFilter={setGlobalFilter}
              isConvertibleCreateOrUpdate={isConvertibleCreateOrUpdate}
              setIsConvertibleCreateOrUpdate={setIsConvertibleCreateOrUpdate}
              setSidebar={setSidebar}
              setIsShareClassDropdown={setIsShareClassDropdown}
              modalType={modalType}
              setModalType={setModalType}
              convertibleClassId={convertibleClassId}
              setConvertibleClassId={setConvertibleClassId}
            />
          </>
        )}{' '}
        {sidebar === 3 && (
          <>
            {/* <WarrantClassTable openModal={openModal} closeModal={closeModal} activeModal={activeModal} selectedIndex={selectedIndex} setSelectedIndex={setSelectedIndex} /> */}
            <DataTableServerWarrantClass
              openModal={openModal}
              closeModal={closeModal}
              activeModal={activeModal}
              setIsCreate={setIsCreate}
              selectedWarrantSecurityClassesSortFilter={selectedWarrantSecurityClassesSortFilter}
              globalFilter={warrantGlobalFilter}
              setGlobalFilter={setGlobalFilter}
              isWarrantCreateOrUpdate={isWarrantCreateOrUpdate}
              setIsWarrantCreateOrUpdate={setIsWarrantCreateOrUpdate}
              setSidebar={setSidebar}
              setIsShareClassDropdown={setIsShareClassDropdown}
              setModalType={setModalType}
              warrantClassId={warrantClassId}
              setWarrantClassId={setWarrantClassId}
            />
          </>
        )}
      </div>
      {activeModal === 'AddSecurityClassModal' && isCreate && (
        <AddSharedClassModal
          openModal={openModal}
          isActive={true}
          setIsActive={closeModal}
          shareClassId={null}
          setIsCreateOrUpdate={setIsCreateOrUpdate}
          setSidebar={setSidebar}
          shareClassDropdown={isShareClassDropdown}
          setShareClassDropdown={setIsShareClassDropdown}
          modalType={modalType}
          setModalType={setModalType}
        />
      )}
      {activeModal === 'AddConvertibleClassModal' && isCreate && (
        <AddConvertibleClassModal
          isActive={true}
          setIsActive={closeModal}
          setIsConvertibleCreateOrUpdate={setIsConvertibleCreateOrUpdate}
          setSidebar={setSidebar}
          convertibleClassId={null}
          openModal={openModal}
          setIsShareClassDropdown={setIsShareClassDropdown}
          setModalType={setModalType}
          setIsCreate={setIsCreate}
        />
      )}
      {activeModal === 'AddWarrantClassModal' && isCreate && (
        <AddWarrantClassModal
          isActive={true}
          setIsActive={closeModal}
          setIsWarrantCreateOrUpdate={setIsWarrantCreateOrUpdate}
          setSidebar={setSidebar}
          warrantClassId={null}
          openModal={openModal}
          setIsShareClassDropdown={setIsShareClassDropdown}
          setModalType={setModalType}
          setIsCreate={setIsCreate}
        />
      )}
      <Filter onResetFilter={onResetFilter} setOnResetFilter={setOnResetFilter} />
    </>
  )
}

function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}: {
  value: string | number
  onChange: (value: string | number) => void
  debounce?: number
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>) {
  const [value, setValue] = useState(initialValue)

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value)
    }, debounce)

    return () => clearTimeout(timeout)
  }, [value, debounce, onChange])
  return <input {...props} value={value} onChange={(e) => setValue(e.target.value)} />
}
